import React, { useEffect, useState } from 'react';
import Slider from 'react-slick/lib/slider';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllPackages } from '../../Redux/Auth/Auth_Action';
import { showLoader } from '../../Redux/services/Loader';
import { toast } from 'react-toastify';

const OurPackages = () => {

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const tokenFromRedux = useSelector((state) => state.Auth.token);
    const [packages, setPackages] = useState([]);
    const [pagination, setPagination] = useState({ paginationData: [] })

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className='Slider_packages_custom_arrows_next'
                // style={{ ...style, display: "none", background: "red", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }


    function SamplePrevArrow(props) {
        const { style, onClick } = props;
        return (
            <div
                className="Slider_packages_custom_arrows_prev"
                // style={{ ...style, display: "none", background: "green", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
        ]
    }

    const PackagesGetAll = () => {
        dispatch(GetAllPackages(tokenFromRedux))
            .then((res) => {
                setPackages(res?.data.data)
                // console.log('data from ourpackages', res?.data?.data);
                // setPagination({ ...pagination, paginationData: res?.data.links })
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        PackagesGetAll();
    }, [])

    // console.log(packages);

    return (
        <div className='packages'>
            <div className='row'>
                <div className='col-lg-12 text-center'>
                    <p className='f-mon-reg f-30 text-white mb-0'>DISCOUNTED PACKAGES</p>
                    <p className='f-mon-bold f-50 text-white lh-01'>GET THE BEST DEALS OUT THERE</p>
                    <div className='border-btm-pink-secondsec'></div>
                    <p className='wdth-80-per text-white f-mon-light f-20 mt-3'>
                        No matter which sports you want to bet on, we got your sport. Choose your desired plan, get your sports betting advice and start winning today!
                    </p>
                    <p className='wdth-80-per text-white f-mon-light f-20 mt-3'>*EVERY NEW SPORTS BETTOR CLIENT RECIEVES A “PREDICTION DOG” T-SHIRT!</p>
                    <p className='wdth-80-per text-white f-mon-light f-20 mt-3'>GET YOUR “DOG” ON!</p>
                    <Slider {...settings} className="mt-5 mb-5">
                        {packages?.map((item, index) => {
                            // console.log("packaes slub", item);
                            return (
                                <div key={index} className='crd-flex'>
                                    <div className='card mx-2 rounded-0 border-0 crd-top-pos h-100'>
                                        <div className='card-body border-0 p-23rem crd-hover-bg tickchange p-white'>
                                            <div className='row'>
                                                <div className='col-lg-12'>
                                                    <p className='card-title mb-2'>{item?.title}</p>
                                                </div>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: item?.package_offer }}
                                                    className='col-lg-12 text-center dan'>
                                                </div>
                                                <div className='flx-bx-price'>
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <div className='price-container'>
                                                                <p className='price mr-1'>{item?.price}</p>
                                                                <p className='delete-price line_over ml-1'> {item?.old_price}</p>
                                                            </div>
                                                        </div>
                                                        <div className='col-lg-12 text-center mt-2'>
                                                            <Link to={"/payment"} state={{ slug: item?.slug, title: item?.title, price: item?.price, limit_intrst: item?.limit_of_interest }}>
                                                                <button className='btn buyPackage'>
                                                                    BUY THIS PACKAGE
                                                                </button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
};

export default OurPackages;